import axios from 'axios';
const subdominio = window.location.hostname.split(".")[0];

const api = axios.create({
    // Produção
    baseURL: "https://apipedidos.sulpasso.com.br",

    // Local
    // baseURL: "https://localhost:7123/",
});

api.interceptors.request.use(config => {
    config.headers["X-Subdominio"] = subdominio;
    return config;
});

export default api;